import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 62px 0px 0px;
`;

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: 24px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    margin: 32px auto 0px;
    max-width: 645px;
    text-align: center;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 4px auto 0px;
    max-width: 645px;
    text-align: center;
  `}
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    margin: 32px auto 0px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column-reverse;
    }
  `}
`;

export const Card = styled.div<{ $lightCard?: boolean }>`
  ${({ theme, $lightCard }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 24px;
    padding: 8px 4px 4px;
    background: ${$lightCard
    ? theme.v3.colors.neutral[95]
    : `linear-gradient(118deg, 
        ${theme.v3.colors.brand.snappyBlue[60]} 13.03%, 
        ${theme.v3.colors.brand.snappyBlue[70]} 27.82%, 
        ${theme.v3.colors.brand.snappyBlue[60]} 42.61%, 
        ${theme.v3.colors.brand.snappyBlue[50]} 57.39%, 
        ${theme.v3.colors.brand.snappyBlue[40]} 72.18%, 
        ${theme.v3.colors.brand.snappyBlue[30]} 86.97%)`};
  `}
`;

export const InnerCard = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    margin: 4px 0px 0px;
    height: 100%;
  `}
`;

export const CardTitle = styled.span<{ $lightCard?: boolean }>`
  ${({ theme, $lightCard }) => css`
    align-items: center;
    color: ${$lightCard ? theme.v3.colors.neutral[30] : theme.v3.colors.neutral[95]};
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.medium};
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0px auto;

    ${!$lightCard && css`
        max-width: 400px;
        width: 100%;
    `}
  `}
`;

export const List = styled.ul`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
  `}
`;

export const ListItem = styled.li`
  ${() => css`
    display:  flex;
    flex-direction: row;
    gap: 20px;
  `}
`;

export const CardTag = styled.span`
    ${({ theme }) => css`
      align-items: center;
      background-color: ${theme.v3.colors.neutral[100]};
      border-radius: 1000px;
      color: ${theme.v3.colors.brand.snappyBlue[30]};
      display: flex;
      flex-direction: row;
      font-size: 14px;
      font-weight: ${theme.v3.font.weights.bold};
      justify-content: center;
      line-height: ${theme.v3.font.lineHeight.compact};
      margin: 0px 8px 0px 0px;
      max-height: 25px;
      padding: 8px;
      width: fit-content;
    `}
`;


export const InnerButtonWrapper = styled.div<{ $gradient?: boolean }>`
    ${({ theme, $gradient }) => css`
      margin-top: auto;

      button{
        cursor: pointer;
        ${$gradient && css`
          span {
            background: linear-gradient(272deg, 
              ${theme.v3.colors.brand.snappyBlue[0]} 1.36%, 
              ${theme.v3.colors.brand.snappyBlue[13]} 13.6%, 
              ${theme.v3.colors.brand.snappyBlue[19]} 19.72%, 
              ${theme.v3.colors.brand.snappyBlue[25]} 25.85%, 
              ${theme.v3.colors.brand.snappyBlue[31]} 38.09%, 
              ${theme.v3.colors.brand.snappyBlue[38]} 31.97%, 
              ${theme.v3.colors.brand.snappyBlue[44]} 44.21%, 
              ${theme.v3.colors.brand.snappyBlue[50]} 50.33%, 
              ${theme.v3.colors.brand.snappyBlue[56]} 56.46%, 
              ${theme.v3.colors.brand.snappyBlue[62]} 62.58%, 
              ${theme.v3.colors.brand.snappyBlue[68]} 68.7%, 
              ${theme.v3.colors.brand.snappyBlue[74]} 74.82%, 
              ${theme.v3.colors.brand.snappyBlue[80]} 80.94%, 
              ${theme.v3.colors.brand.snappyBlue[87]} 87.07%,
              ${theme.v3.colors.brand.snappyBlue[93]} 93.19%,
              ${theme.v3.colors.brand.snappyBlue[99]} 99.31%) !important;
            -webkit-background-clip: text !important;
            background-clip: text !important;
            color: #fff !important;
          }
        `}

        svg {
          path {
            stroke: ${theme.v3.colors.neutral[100]};
          }
        }
      }
    `}
`;

export const TermsText = styled.li`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[98]};
    border-radius: 8px;
    color: ${theme.v3.colors.neutral[20]};
    font-size: 12px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    list-style: none;
    margin: 32px 0px 0px;
    padding: 8px 16px;
    
    a {
      color: ${theme.v3.colors.neutral[20]};
      font-size: 12px !important;
      text-decoration: underline;
    }
  `}
`;

export const SnappyImage = styled.img`
  margin: 9px 0px 0px auto;
  max-width: fit-content;
  position: unset;
`;
